<template>
  <footer>
    <div class="xl:max-w-6xl lg:max-w-full md:max-full w-full mx-auto xl:px-14 px-4 sm:px-6">

      <!-- Blocks -->
      <div class="grid sm:grid-cols-12 gap-8 py-8 md:py-12">

        <!-- 1st block -->
        <div class="sm:col-span-12 lg:col-span-4 ">
          <div class="h-full flex flex-col sm:flex-row lg:flex-col justify-between">
            <div class="mb-2 sm:mb-2">
              <div class="mb-4">
                <!-- Logo -->
                <router-link class="inline-flex" to="/" aria-label="Cruip">
                  <img src="@/assets/images/logo-light.png"  width="200" height="30"  alt="protostars">
                </router-link>
              </div>
              <div class="text-sm text-slate-300">&copy; {{new Date().getFullYear()}} Protostars <span class="text-slate-500">-</span> {{ $t('footer_rights') }}</div>
              <router-link class="block mt-4 text-slate-400 hover:text-slate-200 text-sm transition duration-150 ease-in-out" to="/privacy-policy">{{ $t('privacy_policy_link') }}</router-link>
              <!-- <div class="mt-6 text-slate-400 text-sm font-medium">Follow Us</div> -->
            </div>
            <!-- Social links -->
            <ul class="flex mt-2">
              <li>
                <a class="flex justify-center items-center text-cyan-500 hover:text-cyan-400 transition duration-150 ease-in-out" href="https://www.linkedin.com/company/protostars.ai/posts/?feedView=all&viewAsMember=true" aria-label="LinkedIn" target="_blank" rel="noopener">
                  <svg class="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path d="M27 4H5C4.447 4 4 4.447 4 5v22c0 0.553 0.447 1 1 1h22c0.553 0 1-0.447 1-1V5C28 4.447 27.553 4 27 4zM12.339 24H8.669V13.333h3.67V24zM10.504 11.922c-1.175 0-2.13-0.955-2.13-2.13 0-1.176 0.955-2.13 2.13-2.13 1.176 0 2.13 0.954 2.13 2.13C12.634 10.967 11.68 11.922 10.504 11.922zM24 24h-3.667v-5.333c0-1.271-0.023-2.908-1.773-2.908-1.773 0-2.044 1.385-2.044 2.814V24h-3.667V13.333h3.52v1.453h0.05c0.49-0.927 1.688-1.904 3.477-1.904 3.719 0 4.409 2.448 4.409 5.633V24z"/>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- 2nd block -->
         <!-- <div class="sm:col-span-6 md:col-span-3 lg:col-span-2">
          <h6 class="text-sm text-slate-50 font-medium mb-2">{{$t('footer_col1_title')}}</h6>
          <ul class="text-sm space-y-2">
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col1_item1')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col1_item2')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col1_item3')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col1_item4')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col1_item5')}}</router-link>
            </li>
          </ul>
        </div>  -->

        <!-- 3rd block -->
        <!-- <div class="sm:col-span-6 md:col-span-3 lg:col-span-2">
          <h6 class="text-sm text-slate-50 font-medium mb-2">{{$t('footer_col2_title')}}</h6>
          <ul class="text-sm space-y-2">
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col2_item1')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col2_item2')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col2_item3')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col2_item4')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col2_item5')}}</router-link>
            </li>
          </ul>
        </div> -->

        <!-- 4th block -->
        <!-- <div class="sm:col-span-6 md:col-span-3 lg:col-span-2">
          <h6 class="text-sm text-slate-50 font-medium mb-2">{{$t('footer_col3_title')}}</h6>
          <ul class="text-sm space-y-2">
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col3_item1')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col3_item2')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col3_item3')}}</router-link>
            </li>
          </ul>
        </div> -->

        <!-- 5th block -->
        <!-- <div class="sm:col-span-6 md:col-span-3 lg:col-span-2">
          <h6 class="text-sm text-slate-50 font-medium mb-2">{{$t('footer_col4_title')}}</h6>
          <ul class="text-sm space-y-2">
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col4_item1')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col4_item2')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col4_item3')}}</router-link>
            </li>
            <li>
              <router-link class="text-slate-400 hover:text-slate-200 transition duration-150 ease-in-out" to="/">{{$t('footer_col4_item4')}}</router-link>
            </li>
          </ul>
        </div> -->

      </div>

    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
}
</script>